<div class="flex flex-col fill">
  <mic-header>
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row flex-none items-center">
        <mic-sidebar-toggler [alwaysDisplay]="true" id="main-sidebar-toggler" type="left"></mic-sidebar-toggler>
        <a routerLink="/">
          <mic-logo></mic-logo>
        </a>
      </div>
      <mic-navbar-spacer></mic-navbar-spacer>
      <span class="title md-hidden"></span>
      <mic-navbar-spacer></mic-navbar-spacer>
      <div class="flex flex-row flex-none gap-2 items-center">
        <div class="select-customer-wrapper">
          <mat-icon class="mine-select-icon">domain</mat-icon>
          <mic-dropdown-search
            appearance="outline"
            class="mic-form-field-white header-select-dropdown"
            [label]="'header.customer-select.name' | translate"
            [nullLabel]="'common.filter.all' | translate"
            [placeholder]="loaderConfig.loading == true ? ('autocomplete.loading' | translate) : ('header.customer-select.placeholder' | translate)"
            [emptyPlaceholder]="'common.filter.no-result' | translate"
            [searchPlaceholder]="'common.filter.search' | translate"
            subscriptSizing="dynamic"
            [formControl]="customerCtrl"
            [loaderConfig]="loaderConfig"
            [disabled]="true"
            [data]="customers"
            [attribute]="'name'"
            [compareWith]="compareCustomer"
          >
          </mic-dropdown-search>
        </div>
      </div>
      <div class="flex flex-row flex-none gap-2 items-center">
          <mic-dropdown-search
            appearance="outline"
            class="mic-form-field-white header-select-dropdown"
            [label]="'sites.filter.siteName' | translate"
            [nullLabel]="'sites.filter.all' | translate"
            [placeholder]="loaderConfig.loading ? ('autocomplete.loading' | translate) : ('sites.filter.siteName' | translate)"
            [emptyPlaceholder]="'sites.filter.noResults' | translate"
            [searchPlaceholder]="'sites.filter.search' | translate"
            subscriptSizing="dynamic"
            [formControl]="siteCtrl"
            [loaderConfig]="loaderConfig"
            [data]="filteredSites"
            [attribute]="'name'"
            [compareWith]="compareSites"
          >
          </mic-dropdown-search>
      </div>
      <div class="flex flex-row flex-none gap-2 items-center">
        <div class="user-name" aria-label="user-name" [title]="userClaims.given_name + ' ' + userClaims.family_name">
          {{ userClaims.given_name + ' ' + userClaims.family_name }}
        </div>
        <mic-navbar-spacer fxFlex="1"></mic-navbar-spacer>
        <div (click)="authWrapperService.isAuthenticated() ? logout() : login()">
          <mic-navbar-links>
            <mic-navbar-link
              [link]="null"
              [label]="authWrapperService.isAuthenticated() ? 'Logout' : 'Login'"
              [icon]="authWrapperService.isAuthenticated() ? 'logout' : 'vpn_key'"
              icon="login"
            ></mic-navbar-link>
          </mic-navbar-links>
        </div>
      </div>
    </div>
  </mic-header>
  <mic-sidebar-container leftToggler="main-sidebar-toggler">
    <mic-sidebar position="start">
      <a routerLink="/forecast"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact : true}"
         class="menu-entry"
      >
        <mat-icon class="menu-entry-icon">edit_calendar</mat-icon>
        <span class="menu-label">{{ 'forecast.title' | translate }}</span>
      </a>
      <a routerLink="/stock"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}"
         class="menu-entry"
      >
        <mat-icon class="menu-entry-icon">inventory_2</mat-icon>
        <span class="menu-label">{{ 'stock.title' | translate }}</span>
      </a>
      <a routerLink="/sites"
         routerLinkActive="active"
         class="menu-entry"
      >
        <mat-icon class="menu-entry-icon">signpost_outline</mat-icon>
        <span class="menu-label">{{ 'sites.title' | translate }}</span>
      </a>
      <a routerLink="/fleet"
         routerLinkActive="active"
         class="menu-entry"
      >
        <mat-icon class="menu-entry-icon">front_loader</mat-icon>
        <span class="menu-label">{{ 'fleet.title' | translate }}</span>
      </a>
      <a routerLink="/tire"
         routerLinkActive="active"
         class="menu-entry"
      >
        <mat-icon class="menu-entry-icon">tire_repair</mat-icon>
        <span class="menu-label">{{ 'tire.title' | translate }}</span>
      </a>
      <mic-sidebar-spacer/>
    </mic-sidebar>
    <mic-main-content main>
      <div class="flex flex-col fill justify-center" content>
        <div class="sidebar-container-content">
          <router-outlet/>
        </div>
        <mic-footer>
          <div class="xs-self-center"></div>
          <div class="xs-self-center">Copyright Michelin © </div>
        </mic-footer>
      </div>
    </mic-main-content>
  </mic-sidebar-container>
  <mic-alert-center [hideDelay]="8"></mic-alert-center>
</div>
